import * as etplayer from "./etplayer";
import * as wgt from "./wgt";
import * as modAjax from "./modAjax";
import * as modArchive from "./modArchive";
import * as modImage from "./modImage";
import * as modList from "./modList";

var _playerId: number|null = null;

var _currentPlayer: PlayerInstance|null = null;

type PlaybackState = 'playing'|'paused'|'stopped'|'error';

export class Song {
	id?: number; // undefined if 'stopped'
	type?: string; // undefined if 'stopped'
	title?: string;
	artist?: string;
	picture?: string;
}

class Status {
	player: number|undefined;
	state: PlaybackState = 'error';

	song: Song|undefined;

	time: {
		current: number;
		remaining: number;
		total: number;
	}|undefined

	volume: number|undefined;
	shuffle: boolean|undefined;
	schedulerDisabled: boolean|undefined;

	archiveHash?: string;
	playlistHash?: string;
}

export class PlayerInstance {
	playerId: number;
	pos: number;
	ts: Date;

	state: Status;

	infoReq: EventSource|null;
	infoTimer: number|null;
	checkTimer: number|null;
	reconnectTimer: number|null;

	onStatus = gotStatus

	constructor(playerId: number) {
		this.playerId = playerId;
        this.pos = 0;
        this.state = new Status();
        this.ts = new Date();
		this.infoReq = null;
		this.infoTimer = null;
		this.checkTimer = null;
		this.reconnectTimer = null;
	}

	close() {
		if (this.infoReq) this.infoReq.close();
        if (this.infoTimer) clearInterval(this.infoTimer);
        if (this.checkTimer) clearInterval(this.checkTimer);
        if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
	}

	connect() {
		var self = this;
		if (this.reconnectTimer) clearTimeout(this.reconnectTimer);

		this.infoReq = new EventSource(modAjax.applyBaseURL("/player/"+this.playerId+"/info.stream"), { withCredentials: true } );
		this.infoReq.onmessage = function(data) {
			self._onInfo(data);
		}
		this.infoReq.onerror = function(error) {
			console.error("EventStream error: ", error);

			self.close();

			$('body').addClass('connection-lost');
			self.reconnectTimer = setTimeout(function() {
				// 2022-09-14: we can't figure out the HTTP error code here, so let's instead
				// also fire off a regular AJAX request (in case we get a 401/403 that'll trigger the login form to pop up)
				_fetchInfo();

				// can't use setCurrentPlayer() because it would reset the timers etc.
				self.connect();
			}, 5000);
		}
		this.checkTimer = setInterval(function () {
			self._checkStream()
		}, 2000);
	}

	_checkStream() {
		// will run every two seconds in EventStream mode
		var now = new Date().getTime();
		if (this.ts.getTime() < now - 30000) {
			// the last message we received is older than 30sec -> fall back to polling mode
			_fetchInfo();
		}
	}

	_onInfo(msg: MessageEvent) {
		var player = _currentPlayer;
		if (player == null) return;
		$('body').removeClass('connection-lost');


		var info = JSON.parse(msg.data);
		//console.log('got state: ', info);
		player.state = PlayerInstance._updateDict(player.state, info);
		player.ts = new Date();
		this.onStatus(new etplayer.Result(player.state));
	}

	static _updateDict(oldDict: any, newDict: any) {
		for (var k in newDict) {
			var oldValue = oldDict[k];
			var newValue = newDict[k];
			if (oldValue !== null && typeof(oldValue) === 'object') {
				newValue = PlayerInstance._updateDict(oldDict[k], newValue);
			}
			oldDict[k] = newValue;
		}
		return oldDict;
	}
}

export function clearPlaylist() {
	modList.playlist.showLoadingIndicator();
    modAjax.post("/player/"+getId()+"/playlist/clear").then((data) => {
        modList.playlist.loadData(data);
    });
}

export function drop(ev: JQuery.DropEvent) {
	let dataTransfer = ev.originalEvent?.dataTransfer
	if (dataTransfer === null || dataTransfer === undefined) {
		console.error("modPlayer.drop(): missing drag'n'drop data");
		return;
	}
    var data = JSON.parse(dataTransfer.getData(etplayer.ERT_MIMETYPE));
    if (data.length != 1) {
        throw "can only drop one entity at a time";
    }
    data = data[0];

	modList.playlist.showLoadingIndicator();
    modAjax.post('/player/'+_playerId+"/play", data).then((data) => {
        modList.playlist.loadData(data, true);
    });
}

export function reactivateScheduler() {
	modList.playlist.showLoadingIndicator();
    modAjax.post('/player/'+_playerId+'/enableScheduler').then((data) => {
        $('body').removeClass('schedulerDisabled');
        modList.playlist.loadData(data, true);
    });
}

export function getId(): number|null {
    return _playerId;
}

/// TODO add listPlayers which should return a list of Player{"name": string, "streamUrl": string, ...}
export function getNames(): JQueryDeferred<{[id: string]: string}> {
	var promise = $.Deferred();

	etplayer.getAppState().then((state) => {
		promise.resolve(state.players);
	}, (jqXHR, textStatus, errorThrown) => {
		promise.reject(jqXHR, textStatus, errorThrown);
	})
	return promise;
}

export function setCurrentPlayer(playerId: number): PlayerInstance {
    playerId = parseInt(playerId.toString());
    _playerId = playerId;
    console.log("active player: ", playerId+1);
    // close old request
    if (_currentPlayer != null) {
        _currentPlayer.close();
        _currentPlayer = null;
    }

    // create new one
    _currentPlayer = new PlayerInstance(playerId);

    try {
        _currentPlayer.connect();
    } catch(e) {
        console.error("Missing EventStream support! Falling back to polling :(");
        _currentPlayer.infoTimer = setInterval(_fetchInfo, 2000);
    }
	return _currentPlayer;
}

function _fetchInfo() {
	if (_currentPlayer == null) return; // no active player (yet)
    modAjax.request('player/'+_currentPlayer.playerId+'/info').then((data) => {
        console.log('gotPlayerStatus: ', data);
        gotStatus(data);
    });
}

export function gotStatus(data: etplayer.Result<Status>) {
	if (!data) return;
	var result = data.result;
	if (!result) return;

	var $playlist = $('#playlist');
	var title: string|undefined, artist: string|undefined, picture: string|undefined;
	if (result.song) {
		title = result.song.title;
		artist = result.song.artist;

		if (result.song.id != null && result.song.type != null) {
			$playlist.trigger('songChanged', [result.song]);
		}
		else {
			$playlist.trigger('songChanged', [null])
		}

		if (result.song.picture) {
			// TODO this isn't used anywhere
			picture = modAjax.applyBaseURL('/archive/picture?id='+result.song.picture);
		}
	}
	if (result.playlistHash !== undefined && result.playlistHash != $playlist.data('_hash')) {
		console.log("playlist changed, reloading...")
		modList.playlist.showLoadingIndicator();
		modAjax.request('player/'+result.player+'/playlist').then((data) => {
			modList.playlist.loadData(data, true);
		});
		$playlist.data('_hash', result.playlistHash); // update it so we won't cause multiple AJAX requests
	}
	var $archive = $('#archive');
	if ($archive.length > 0 && result.archiveHash !== undefined && result.archiveHash != $archive.data('_hash')) {
		console.log("archive changed, reloading...")
		modArchive.reloadWidget();
		$archive.data('_hash', result.archiveHash);
	}

	switch (result.state) {
	case "playing":
	case "paused":
		break; // ignored
	case "stopped":
		title = "stopped";
		artist = "";
		break;
	case "error":
		title = "error";
		artist = "";
		break;
	default:
		console.error("unsupported player state: ", result.state);
	}

	if (title == undefined) title = '';
	if (artist == undefined) artist = '';

	_setText("#title", title);
	_setText("#artist", artist);

	var currentTime = 0, remainingTime = 0, totalTime = 0;
	if (result.time) {
		currentTime = result.time.current / 1000;
		remainingTime = result.time.remaining / 1000;
		totalTime = result.time.total / 1000;
		if (result.time.total <= 0) {
			remainingTime = -1;
			totalTime = -1;
		}
	}
	$('#currentTime').text(etplayer.formatDuration(currentTime))
	$('#remainingTime').text(etplayer.formatDuration(remainingTime))

	var seekBar = wgt.ProgressBar('#timeProgress');
	seekBar.setMax(totalTime);
	seekBar.setValue(currentTime);

	var btn = $('#playPauseBtn');
	if (result.state == "playing") btn.removeClass('paused').addClass('playing');
	else btn.removeClass('playing').addClass('paused');

	if ("volume" in result) {
		var volume = result.volume;
		if (volume != undefined) wgt.ProgressBar('#volume').setValue(volume);
	}
	if ("shuffle" in result) {
		if (result.shuffle) $('#shuffleBtn.shuffleOff').removeClass('shuffleOff').addClass('shuffleOn');
		else $('#shuffleBtn.shuffleOn').removeClass('shuffleOn').addClass('shuffleOff');
	}

	if ("schedulerDisabled" in result) {
		if (result.schedulerDisabled) $('body').addClass('schedulerDisabled');
		else $('body').removeClass('schedulerDisabled');
	}

	let $albumImg = $('.albumArt');
	if ($albumImg.length > 0) {
		modImage.loadImage($albumImg, picture);
	}
}

function _setText(selector: string, text: string) {
	var $elem = $(selector);
	if ($elem.hasClass('trackInfo')) {
		wgt.TrackInfo($elem).setText(text);
	}
	else {
		var origWidth = $elem.width();
		if (origWidth == undefined) throw "wgt._setText(): missing origWidth";
		$elem.text(text);
		$elem.width(origWidth);
	}
}


function postCommand(cmd: string, data?: string | JQuery.PlainObject<any>) {
	modAjax.request('player/'+getId()+'/'+cmd, data, {
		dataType: 'json',
		method: 'POST',
	}).then(gotStatus)
}

export function prev() { postCommand('prev'); }
export function playPause() { postCommand('playPause'); }
export function next() { postCommand('next'); }

export function seek(msec: number) {
    postCommand('seek', {'msec': msec});
}

export function toggleShuffle() {
    var data = {'shuffle': 'toggle'};
	modList.playlist.showLoadingIndicator();
    modAjax.post("/player/"+getId()+"/playlist/shuffle", data).then((data) => {
        modList.playlist.loadData(data);
        //loadAppState();
        if ('shuffle' in data.result) {
            if (data.result.shuffle) $('#shuffleBtn').removeClass('shuffleOff').addClass('shuffleOn');
            else $('#shuffleBtn').removeClass('shuffleOn').addClass('shuffleOff');
        }
    });
}


$(function() {
	// for android: dis-/reconnect to the EventSource on app stop/resume
	window.addEventListener('appStop', function() {
		if (_currentPlayer != null) {
			console.log('app lost focus, closing EventSource');
			_currentPlayer.close();
			_currentPlayer = null;
		}
	});

	window.addEventListener('appResume', function() {
		console.log('app regained focus, resuming EventSource');
		if (_playerId !== null) setCurrentPlayer(_playerId)
	});
});
